// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Container,
//   Grid,
//   TextField,
//   Typography,
//   IconButton,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemButton,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   FormControl,
//   FormLabel,
//   LinearProgress,
//   Alert,
//   Box,
//   Paper,
//   Divider
// } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';
// import { useStateValue } from '../../contexto/store';
// import { obtenerClientes } from '../../actions/ClientesAction';


// // Modal para seleccionar cliente
// const ModalClientes = ({ open, handleClose, data, seleccionarCliente, datosCargados }) => {
//   const [filtro, setFiltro] = useState('');
  
//   const clientesFiltrados = data.filter(cliente => 
//     cliente.nombre?.toLowerCase().includes(filtro.toLowerCase()) ||
//     cliente.apellido?.toLowerCase().includes(filtro.toLowerCase())
//   );

//   return (
//     <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
//       <DialogTitle>Seleccionar Cliente</DialogTitle>
//       <DialogContent>
//         <TextField
//           fullWidth
//           variant="outlined"
//           placeholder="Buscar cliente..."
//           value={filtro}
//           onChange={(e) => setFiltro(e.target.value)}
//           margin="normal"
//         />
//         {!datosCargados ? (
//           <LinearProgress />
//         ) : (
//           <List sx={{ maxHeight: 400, overflow: 'auto' }}>
//             {clientesFiltrados.map((cliente) => (
//               <ListItem key={cliente.clientE_Id} disablePadding>
//                 <ListItemButton onClick={() => seleccionarCliente(cliente)}>
//                   <ListItemText 
//                     primary={`${cliente.nombre} ${cliente.apellido}`}
//                     secondary={cliente.email || cliente.telefono}
//                   />
//                 </ListItemButton>
//               </ListItem>
//             ))}
//           </List>
//         )}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={handleClose}>Cancelar</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// // Modal para seleccionar encuesta
// const ModalEncuestas = ({ open, handleClose, data, seleccionarEncuesta, datosCargados }) => {
//   return (
//     <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
//       <DialogTitle>Seleccionar Encuesta</DialogTitle>
//       <DialogContent>
//         {!datosCargados ? (
//           <LinearProgress />
//         ) : (
//           <List>
//             {data.map((encuesta) => (
//               <ListItem key={encuesta.id} disablePadding>
//                 <ListItemButton onClick={() => seleccionarEncuesta(encuesta)}>
//                   <ListItemText 
//                     primary={encuesta.titulo}
//                     secondary={encuesta.descripcion || 'Encuesta disponible'}
//                   />
//                 </ListItemButton>
//               </ListItem>
//             ))}
//           </List>
//         )}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={handleClose}>Cancelar</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default function RealizarEncuesta(props) {
//   const mounted = useRef(true);
//   const [{ sesionUsuario }, dispatch] = useStateValue();
  
//   // Estados para datos
//   const [clientes, setClientes] = useState([]);
//   const [encuestas, setEncuestas] = useState([]);
//   const [preguntas, setPreguntas] = useState([]);
//   const [datosCargados, setDatosCargados] = useState(false);
//   const [encuestasCargadas, setEncuestasCargadas] = useState(false);
  
//   // Estados para modales
//   const [modalClientes, setModalClientes] = useState(false);
//   const [modalEncuestas, setModalEncuestas] = useState(false);
  
//   // Estados del formulario
//   const [encuesta, setEncuesta] = useState({
//     CLIENTE_ID: '',
//     CLIENTE: '',
//     ENCUESTA_ID: '',
//     ENCUESTA: '',
//     RESPUESTAS: {}
//   });
  
//   const [loading, setLoading] = useState(false);

//   // Simulación de datos - reemplaza con tu API real
//   const mockClientes = [
//     { clientE_Id: '1', nombre: 'Empresa', apellido: 'ABC S.A.', email: 'abc@empresa.com' },
//     { clientE_Id: '2', nombre: 'Corporación', apellido: 'XYZ Ltda.', email: 'xyz@corp.com' },
//     { clientE_Id: '3', nombre: 'Industrias', apellido: 'DEF S.R.L.', email: 'def@industrias.com' }
//   ];

//   const mockEncuestas = [
//     { id: '1', titulo: 'Satisfacción del Cliente 2024', descripcion: 'Evaluación anual de satisfacción' },
//     { id: '2', titulo: 'Evaluación de Servicios', descripcion: 'Calidad de nuestros servicios' },
//     { id: '3', titulo: 'Feedback Post-Venta', descripcion: 'Experiencia posterior a la compra' }
//   ];

//   const mockPreguntas = [
//     {
//       id: '1',
//       texto: '¿Cómo calificaría la calidad general de nuestros servicios?',
//       opciones: [
//         { id: 'a', texto: 'Excelente' },
//         { id: 'b', texto: 'Muy buena' },
//         { id: 'c', texto: 'Buena' },
//         { id: 'd', texto: 'Regular' },
//         { id: 'e', texto: 'Deficiente' }
//       ]
//     },
//     {
//       id: '2',
//       texto: '¿Recomendaría nuestros servicios a otros?',
//       opciones: [
//         { id: 'a', texto: 'Definitivamente sí' },
//         { id: 'b', texto: 'Probablemente sí' },
//         { id: 'c', texto: 'No estoy seguro' },
//         { id: 'd', texto: 'Probablemente no' },
//         { id: 'e', texto: 'Definitivamente no' }
//       ]
//     },
//     {
//       id: '3',
//       texto: '¿Qué tan satisfecho está con el tiempo de respuesta?',
//       opciones: [
//         { id: 'a', texto: 'Muy satisfecho' },
//         { id: 'b', texto: 'Satisfecho' },
//         { id: 'c', texto: 'Neutral' },
//         { id: 'd', texto: 'Insatisfecho' },
//         { id: 'e', texto: 'Muy insatisfecho' }
//       ]
//     }
//   ];

//   // Funciones para abrir/cerrar modales
//   const abrirModalClientes = () => setModalClientes(true);
//   const cerrarModalClientes = () => setModalClientes(false);
//   const abrirModalEncuestas = () => setModalEncuestas(true);
//   const cerrarModalEncuestas = () => setModalEncuestas(false);

//   // Seleccionar cliente
//   const seleccionarCliente = (cliente) => {
//     setEncuesta(prev => ({
//       ...prev,
//       CLIENTE_ID: cliente.clientE_Id,
//       CLIENTE: `${cliente.nombre} ${cliente.apellido}`,
//       ENCUESTA_ID: '',
//       ENCUESTA: '',
//       RESPUESTAS: {}
//     }));
//     setEncuestas([]);
//     setPreguntas([]);
//     setEncuestasCargadas(false);
//     cerrarModalClientes();
    
//     // Cargar encuestas disponibles para el cliente
//     setLoading(true);
//     setTimeout(() => {
//       // Simular llamada a API: /api/Encuesta/disponibles/${cliente.clientE_Id}
//       setEncuestas(mockEncuestas);
//       setEncuestasCargadas(true);
//       setLoading(false);
//     }, 500);
//   };

//   // Seleccionar encuesta
//   const seleccionarEncuesta = (encuestaSeleccionada) => {
//     setEncuesta(prev => ({
//       ...prev,
//       ENCUESTA_ID: encuestaSeleccionada.id,
//       ENCUESTA: encuestaSeleccionada.titulo,
//       RESPUESTAS: {}
//     }));
//     setPreguntas([]);
//     cerrarModalEncuestas();
    
//     // Cargar preguntas de la encuesta
//     setLoading(true);
//     setTimeout(() => {
//       // Simular llamada a API: /api/Encuesta/${encuestaSeleccionada.id}/preguntas
//       setPreguntas(mockPreguntas);
//       setLoading(false);
//     }, 500);
//   };

//   // Manejar cambios en respuestas
//   const handleRespuestaChange = (preguntaId, opcionId) => {
//     setEncuesta(prev => ({
//       ...prev,
//       RESPUESTAS: {
//         ...prev.RESPUESTAS,
//         [preguntaId]: opcionId
//       }
//     }));
//   };

//   // Enviar encuesta
//   const enviarEncuesta = () => {
//     // Validaciones
//     if (!encuesta.CLIENTE_ID || !encuesta.ENCUESTA_ID) {
//       dispatch({
//         type: 'OPEN_SNACKBAR',
//         openMensaje: {
//           open: true,
//           mensaje: 'Debe seleccionar un cliente y una encuesta',
//         },
//       });
//       return;
//     }

//     const preguntasSinResponder = preguntas.filter(p => !encuesta.RESPUESTAS[p.id]);
//     if (preguntasSinResponder.length > 0) {
//       dispatch({
//         type: 'OPEN_SNACKBAR',
//         openMensaje: {
//           open: true,
//           mensaje: 'Por favor, responda todas las preguntas antes de enviar',
//         },
//       });
//       return;
//     }

//     setLoading(true);
    
//     // Preparar datos para enviar
//     const datosRespuesta = {
//       clienteId: encuesta.CLIENTE_ID,
//       encuestaId: encuesta.ENCUESTA_ID,
//       respuestas: Object.entries(encuesta.RESPUESTAS).map(([preguntaId, opcionId]) => ({
//         preguntaId,
//         opcionId
//       })),
//       usuarioId: sesionUsuario.usuario.id
//     };

//     // Simular envío - reemplazar con tu API real
//     setTimeout(() => {
//       // registrarRespuestaEncuesta(datosRespuesta)
//       setLoading(false);
//       dispatch({
//         type: 'OPEN_SNACKBAR',
//         openMensaje: {
//           open: true,
//           mensaje: 'Encuesta completada exitosamente',
//         },
//       });
      
//       // Limpiar formulario
//       setEncuesta({
//         CLIENTE_ID: '',
//         CLIENTE: '',
//         ENCUESTA_ID: '',
//         ENCUESTA: '',
//         RESPUESTAS: {}
//       });
//       setPreguntas([]);
//       setEncuestas([]);
      
//       // Registrar acción en auditoría
//       // RegistrarAccion({
//       //   usuario: sesionUsuario.usuario.nombrecompleto,
//       //   accion: 'Completó Encuesta',
//       //   panel: 'Gestión de Encuestas',
//       //   tabla: 'ENCUESTAS_RESPUESTAS',
//       //   filaafectada: encuesta.ENCUESTA,
//       //   UsuarioId: sesionUsuario.usuario.id,
//       // });
//     }, 1000);
//   };

//   const volver = () => {
//     props.history.goBack();
//   };

//   useEffect(() => {
//     if (mounted.current) {
//       // Cargar clientes al montar el componente
//       obtenerClientes().then((response) => {
//         if (response.status === 200) {
//           setClientes(response.data);
//           setDatosCargados(true);
//         }
//       });

//     }
    
//     return function cleanup() {
//       mounted.current = false;
//     };
//   }, []);

//   const progreso = () => {
//     if (!encuesta.CLIENTE_ID) return 0;
//     if (!encuesta.ENCUESTA_ID) return 33;
//     if (preguntas.length === 0) return 66;
//     return 100;
//   };

//   return (
//     <Container justify="center" maxWidth="lg">
//       <br />
//       <Typography align="center" variant="h4" gutterBottom>
//         Realizar Encuesta
//       </Typography>
//       <Typography align="center" variant="subtitle1" color="textSecondary" gutterBottom>
//         Seleccione un cliente y complete la encuesta correspondiente
//       </Typography>
      
//       {/* Barra de progreso */}
//       <Box sx={{ width: '100%', mb: 4 }}>
//         <LinearProgress variant="determinate" value={progreso()} sx={{ height: 8, borderRadius: 4 }} />
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
//           <Typography variant="caption">Cliente</Typography>
//           <Typography variant="caption">Encuesta</Typography>
//           <Typography variant="caption">Preguntas</Typography>
//           <Typography variant="caption">Completar</Typography>
//         </Box>
//       </Box>

//       {loading && <LinearProgress sx={{ mb: 2 }} />}

//       <Grid container spacing={4}>
//         {/* Selección de Cliente */}
//         <Grid item xs={12}>
//           <Paper elevation={2} sx={{ p: 3 }}>
//             <Typography variant="h6" gutterBottom>
//               1. Seleccionar Cliente
//             </Typography>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={10}>
//                 <TextField
//                   fullWidth
//                   disabled
//                   variant="outlined"
//                   value={encuesta.CLIENTE}
//                   label="Cliente Seleccionado"
//                   placeholder="Haga clic en el botón de búsqueda para seleccionar un cliente"
//                 />
//               </Grid>
//               <Grid item xs={2}>
//                 <IconButton
//                   onClick={abrirModalClientes}
//                   color="primary"
//                   size="large"
//                   sx={{ 
//                     border: 1, 
//                     borderColor: 'primary.main',
//                     '&:hover': { 
//                       backgroundColor: 'primary.light',
//                       color: 'white'
//                     }
//                   }}
//                 >
//                   <SearchIcon />
//                 </IconButton>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         {/* Selección de Encuesta */}
//         {encuesta.CLIENTE_ID && (
//           <Grid item xs={12}>
//             <Paper elevation={2} sx={{ p: 3 }}>
//               <Typography variant="h6" gutterBottom>
//                 2. Seleccionar Encuesta
//               </Typography>
//               <Grid container spacing={2} alignItems="center">
//                 <Grid item xs={10}>
//                   <TextField
//                     fullWidth
//                     disabled
//                     variant="outlined"
//                     value={encuesta.ENCUESTA}
//                     label="Encuesta Seleccionada"
//                     placeholder="Haga clic en el botón de búsqueda para seleccionar una encuesta"
//                   />
//                 </Grid>
//                 <Grid item xs={2}>
//                   <IconButton
//                     onClick={abrirModalEncuestas}
//                     color="primary"
//                     size="large"
//                     disabled={!encuestasCargadas}
//                     sx={{ 
//                       border: 1, 
//                       borderColor: 'primary.main',
//                       '&:hover': { 
//                         backgroundColor: 'primary.light',
//                         color: 'white'
//                       }
//                     }}
//                   >
//                     <SearchIcon />
//                   </IconButton>
//                 </Grid>
//               </Grid>
//             </Paper>
//           </Grid>
//         )}

//         {/* Preguntas de la Encuesta */}
//         {preguntas.length > 0 && (
//           <Grid item xs={12}>
//             <Paper elevation={2} sx={{ p: 3 }}>
//               <Typography variant="h6" gutterBottom>
//                 3. Responder Preguntas
//               </Typography>
//               {preguntas.map((pregunta, index) => (
//                 <Box key={pregunta.id} sx={{ mb: 4 }}>
//                   <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
//                     {index + 1}. {pregunta.texto}
//                   </Typography>
//                   <FormControl component="fieldset">
//                     <RadioGroup
//                       value={encuesta.RESPUESTAS[pregunta.id] || ''}
//                       onChange={(e) => handleRespuestaChange(pregunta.id, e.target.value)}
//                     >
//                       {pregunta.opciones.map((opcion) => (
//                         <FormControlLabel
//                           key={opcion.id}
//                           value={opcion.id}
//                           control={<Radio />}
//                           label={opcion.texto}
//                           sx={{ 
//                             '&:hover': { 
//                               backgroundColor: 'rgba(0, 0, 0, 0.04)',
//                               borderRadius: 1
//                             }
//                           }}
//                         />
//                       ))}
//                     </RadioGroup>
//                   </FormControl>
//                   {index < preguntas.length - 1 && <Divider sx={{ mt: 2 }} />}
//                 </Box>
//               ))}
//             </Paper>
//           </Grid>
//         )}

//         {/* Botones de Acción */}
//         {preguntas.length > 0 && (
//           <Grid item xs={12}>
//             <Grid container spacing={2} justifyContent="center">
//               <Grid item xs={12} sm={6} md={3}>
//                 <Button
//                   fullWidth
//                   variant="contained"
//                   color="primary"
//                   size="large"
//                   onClick={enviarEncuesta}
//                   disabled={loading || Object.keys(encuesta.RESPUESTAS).length !== preguntas.length}
//                   sx={{ py: 1.5 }}
//                 >
//                   {loading ? 'Enviando...' : 'Enviar Encuesta'}
//                 </Button>
//               </Grid>
//               <Grid item xs={12} sm={6} md={3}>
//                 <Button
//                   fullWidth
//                   variant="outlined"
//                   color="primary"
//                   size="large"
//                   onClick={volver}
//                   sx={{ py: 1.5 }}
//                 >
//                   Volver
//                 </Button>
//               </Grid>
//             </Grid>
//           </Grid>
//         )}
//       </Grid>

//       {/* Modales */}
//       <ModalClientes
//         open={modalClientes}
//         handleClose={cerrarModalClientes}
//         data={clientes}
//         seleccionarCliente={seleccionarCliente}
//         datosCargados={datosCargados}
//       />

//       <ModalEncuestas
//         open={modalEncuestas}
//         handleClose={cerrarModalEncuestas}
//         data={encuestas}
//         seleccionarEncuesta={seleccionarEncuesta}
//         datosCargados={encuestasCargadas}
//       />
//     </Container>
//   );
// }
import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Grid,
  TextField,
  Typography,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  LinearProgress,
  Box,
  Paper,
  Divider
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useStateValue } from '../../contexto/store';
import { obtenerClientes } from '../../actions/ClientesAction';
import { 
  obtenerEncuestasDisponibles, 
  obtenerPreguntasEncuesta, 
  guardarRespuestaEncuesta 
} from '../../actions/EncuestaAction';

// Modal para seleccionar cliente
const ModalClientes = ({ open, handleClose, data, seleccionarCliente, datosCargados }) => {
  const [filtro, setFiltro] = useState('');
  
  const clientesFiltrados = data.filter(cliente => 
    cliente.nombre?.toLowerCase().includes(filtro.toLowerCase()) ||
    cliente.apellido?.toLowerCase().includes(filtro.toLowerCase())
  );

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Seleccionar Cliente</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar cliente..."
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
          margin="normal"
        />
        {!datosCargados ? (
          <LinearProgress />
        ) : (
          <List sx={{ maxHeight: 400, overflow: 'auto' }}>
            {clientesFiltrados.map((cliente) => (
              <ListItem key={cliente.clientE_Id} disablePadding>
                <ListItemButton onClick={() => seleccionarCliente(cliente)}>
                  <ListItemText 
                   primary={`${cliente.nombre}${cliente.apellido ? ` ${cliente.apellido}` : ''}`}
                    secondary={cliente.ci || cliente.ruc}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
};

// Modal para seleccionar encuesta
// const ModalEncuestas = ({ open, handleClose, data, seleccionarEncuesta, datosCargados }) => {
//   const [filtro, setFiltro] = useState('');
  
//   const encuestasFiltradas = data.filter(encuesta => 
//     encuesta.titulo?.toLowerCase().includes(filtro.toLowerCase()) ||
//     encuesta.descripcion?.toLowerCase().includes(filtro.toLowerCase())
//   );

//   return (
//     <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
//       <DialogTitle>Seleccionar Encuesta</DialogTitle>
//       <DialogContent>
//         <TextField
//           fullWidth
//           variant="outlined"
//           placeholder="Buscar encuesta..."
//           value={filtro}
//           onChange={(e) => setFiltro(e.target.value)}
//           margin="normal"
//         />
//         {!datosCargados ? (
//           <LinearProgress />
//         ) : (
//           <List sx={{ maxHeight: 400, overflow: 'auto' }}>
//             {encuestasFiltradas.map((encuesta) => (
//               <ListItem key={encuesta.id} disablePadding>
//                 <ListItemButton onClick={() => seleccionarEncuesta(encuesta)}>
//                   <ListItemText 
//                     primary={encuesta.titulo}
//                     secondary={encuesta.descripcion || 'Encuesta disponible'}
//                   />
//                 </ListItemButton>
//               </ListItem>
//             ))}
//           </List>
//         )}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={handleClose}>Cancelar</Button>
//       </DialogActions>
//     </Dialog>
//   );
// };
// Modal para seleccionar encuesta
const ModalEncuestas = ({ open, handleClose, data, seleccionarEncuesta, datosCargados }) => {
  const [filtro, setFiltro] = useState('');
  
  const encuestasFiltradas = Array.isArray(data) ? data.filter(encuesta => // Aseguramos que 'data' sea un array
    encuesta.titulo?.toLowerCase().includes(filtro.toLowerCase()) ||
    encuesta.contextoTipo?.toLowerCase().includes(filtro.toLowerCase()) // <-- Usa contextoTipo aquí
  ) : [];

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Seleccionar Encuesta</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar encuesta..."
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
          margin="normal"
        />
        {!datosCargados ? (
          <LinearProgress />
        ) : (
          <List sx={{ maxHeight: 400, overflow: 'auto' }}>
            {encuestasFiltradas.map((encuesta) => ( // Usa encuestasFiltradas aquí
              <ListItem key={encuesta.encuestaId} disablePadding> {/* Usa encuestaId */}
                <ListItemButton onClick={() => seleccionarEncuesta(encuesta)}>
                  <ListItemText 
                    primary={encuesta.titulo}
                    secondary={encuesta.contextoTipo || 'Encuesta disponible'} 
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
};
export default function RealizarEncuesta(props) {
  const mounted = useRef(true);
  const [{ sesionUsuario }, dispatch] = useStateValue();
  
  // Estados para datos
  const [clientes, setClientes] = useState([]);
  const [encuestas, setEncuestas] = useState([]);
  const [preguntas, setPreguntas] = useState([]);
  const [datosCargados, setDatosCargados] = useState(false);
  const [encuestasCargadas, setEncuestasCargadas] = useState(false);
  const [preguntasCargadas, setPreguntasCargadas] = useState(false);
  
  // Estados para modales
  const [modalClientes, setModalClientes] = useState(false);
  const [modalEncuestas, setModalEncuestas] = useState(false);
  
  // Estados del formulario
  const [encuesta, setEncuesta] = useState({
    CLIENTE_ID: '',
    CLIENTE: '',
    ENCUESTA_ID: '',
    ENCUESTA: '',
    CONTEXTO_ID: '', 
    RESPUESTAS: {}
  });
  
  const [loading, setLoading] = useState(false);

  // Funciones para abrir/cerrar modales
  const abrirModalClientes = () => setModalClientes(true);
  const cerrarModalClientes = () => setModalClientes(false);
  const abrirModalEncuestas = () => setModalEncuestas(true);
  const cerrarModalEncuestas = () => setModalEncuestas(false);

  // Seleccionar cliente
  const seleccionarCliente = async (cliente) => {
    setEncuesta(prev => ({
      ...prev,
      CLIENTE_ID: cliente.clientE_Id,
      CLIENTE: `${cliente.nombre} ${cliente.apellido}`,
      ENCUESTA_ID: '',
      ENCUESTA: '',
      RESPUESTAS: {}
    }));
    setEncuestas([]);
    setPreguntas([]);
    setEncuestasCargadas(false);
    setPreguntasCargadas(false);
    cerrarModalClientes();
    
    // Cargar encuestas disponibles para el cliente
    setLoading(true);
    console.log("cliente.clientE_Id:", cliente.clientE_Id);
    try {
      const response = await obtenerEncuestasDisponibles(cliente.clientE_Id);
     // console.log("Datos recibidos para encuestas:", response.data);
      if (response.status === 200) {
        setEncuestas(response.data);
        setEncuestasCargadas(true);
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Error al cargar encuestas disponibles',
          },
        });
      }
    } catch (error) {
      console.error('Error al obtener encuestas:', error);
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'Error al cargar encuestas disponibles',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  // Seleccionar encuesta
  const seleccionarEncuesta = async (encuestaSeleccionada) => {
    setEncuesta(prev => ({
      ...prev,
      ENCUESTA_ID: encuestaSeleccionada.encuestaId,
      ENCUESTA: encuestaSeleccionada.titulo,
      CONTEXTO_ID: encuestaSeleccionada.contextoId,
      RESPUESTAS: {}
    }));
    setPreguntas([]);
    setPreguntasCargadas(false);
    cerrarModalEncuestas();
    
    // Cargar preguntas de la encuesta
    setLoading(true);
    try {
      const response = await obtenerPreguntasEncuesta(encuestaSeleccionada.encuestaId);
      if (response.status === 200) {
        setPreguntas(response.data);
        setPreguntasCargadas(true);
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Error al cargar las preguntas de la encuesta',
          },
        });
      }
    } catch (error) {
      console.error('Error al obtener preguntas:', error);
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'Error al cargar las preguntas de la encuesta',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  // Manejar cambios en respuestas
  const handleRespuestaChange = (preguntaId, opcionId) => {
    setEncuesta(prev => ({
      ...prev,
      RESPUESTAS: {
        ...prev.RESPUESTAS,
        [preguntaId]: opcionId
      }
    }));
  };

  // Enviar encuesta
  const enviarEncuesta = async () => {
    // Validaciones
    if (!encuesta.CLIENTE_ID || !encuesta.ENCUESTA_ID) {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'Debe seleccionar un cliente y una encuesta',
        },
      });
      return;
    }

    const preguntasSinResponder = preguntas.filter(p => !encuesta.RESPUESTAS[p.preguntaId]);
    if (preguntasSinResponder.length > 0) {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'Por favor, responda todas las preguntas antes de enviar',
        },
      });
      return;
    }

    setLoading(true);
    
    // Preparar datos para enviar según el formato del backend
    const datosRespuesta = {
      ClienteId: encuesta.CLIENTE_ID,   
      EncuestaId: encuesta.ENCUESTA_ID,
      UsuarioId: sesionUsuario.usuario.id,
      ContextoId: encuesta.CONTEXTO_ID, 
      Respuestas: Object.entries(encuesta.RESPUESTAS).map(([preguntaId, opcionId]) => ({
        preguntaId: preguntaId,
        opcionRespuestaId: opcionId
      }))
    };

    try {
      const response = await guardarRespuestaEncuesta(datosRespuesta);
      
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: response.data?.mensaje || 'Encuesta completada exitosamente',
          },
        });
        
        // Limpiar formulario
        setEncuesta({
          CLIENTE_ID: '',
          CLIENTE: '',
          ENCUESTA_ID: '',
          ENCUESTA: '',
          RESPUESTAS: {}
        });
        setPreguntas([]);
        setEncuestas([]);
        setPreguntasCargadas(false);
        setEncuestasCargadas(false);

      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: response.data?.mensaje || 'Error al guardar la encuesta',
          },
        });
      }
    } catch (error) {
      console.error('Error al enviar encuesta:', error);
      const mensajeError = error.response?.data?.mensaje || 
                          error.response?.data || 
                          'Error al enviar la encuesta. Intente nuevamente.';
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: mensajeError,
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const volver = () => {
    props.history.goBack();
  };

  useEffect(() => {
    if (mounted.current) {
      // Cargar clientes al montar el componente
      obtenerClientes().then((response) => {
        if (response.status === 200) {
          setClientes(response.data);
          setDatosCargados(true);
        } else {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Error al cargar la lista de clientes',
            },
          });
        }
      }).catch((error) => {
        console.error('Error al obtener clientes:', error);
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Error al cargar la lista de clientes',
          },
        });
      });
    }
    
    return function cleanup() {
      mounted.current = false;
    };
  }, [dispatch]);

  const progreso = () => {
    if (!encuesta.CLIENTE_ID) return 0;
    if (!encuesta.ENCUESTA_ID) return 33;
    if (preguntas.length === 0) return 66;
    return 100;
  };

  return (
    <Container justify="center" maxWidth="lg">
      <br />
      <Typography align="center" variant="h4" gutterBottom>
        Realizar Encuesta
      </Typography>
      <Typography align="center" variant="subtitle1" color="textSecondary" gutterBottom>
        Seleccione un cliente y complete la encuesta correspondiente
      </Typography>
      
      {/* Barra de progreso */}
      <Box sx={{ width: '100%', mb: 4 }}>
        <LinearProgress variant="determinate" value={progreso()} sx={{ height: 8, borderRadius: 4 }} />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
          <Typography variant="caption">Cliente</Typography>
          <Typography variant="caption">Encuesta</Typography>
          <Typography variant="caption">Preguntas</Typography>
          <Typography variant="caption">Completar</Typography>
        </Box>
      </Box>

      {loading && <LinearProgress sx={{ mb: 2 }} />}

      <Grid container spacing={4}>
        {/* Selección de Cliente */}
        <Grid item xs={12}>
          <Paper elevation={2} sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              1. Seleccionar Cliente
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={10}>
                <TextField
                  fullWidth
                  disabled
                  variant="outlined"
                  value={encuesta.CLIENTE}
                  label="Cliente Seleccionado"
                  placeholder="Haga clic en el botón de búsqueda para seleccionar un cliente"
                />
              </Grid>
              <Grid item xs={2}>
                <IconButton
                  onClick={abrirModalClientes}
                  color="primary"
                  size="large"
                  sx={{ 
                    border: 1, 
                    borderColor: 'primary.main',
                    '&:hover': { 
                      backgroundColor: 'primary.light',
                      color: 'white'
                    }
                  }}
                >
                  <SearchIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Selección de Encuesta */}
        {encuesta.CLIENTE_ID && (
          <Grid item xs={12}>
            <Paper elevation={2} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                2. Seleccionar Encuesta
              </Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    disabled
                    variant="outlined"
                    value={encuesta.ENCUESTA}
                    label="Encuesta Seleccionada"
                    placeholder="Haga clic en el botón de búsqueda para seleccionar una encuesta"
                  />
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    onClick={abrirModalEncuestas}
                    color="primary"
                    size="large"
                    disabled={!encuestasCargadas}
                    sx={{ 
                      border: 1, 
                      borderColor: 'primary.main',
                      '&:hover': { 
                        backgroundColor: 'primary.light',
                        color: 'white'
                      }
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}

        {/* Preguntas de la Encuesta */}
        {preguntas.length > 0 && (
          <Grid item xs={12}>
            <Paper elevation={2} sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                3. Responder Preguntas
              </Typography>
              {preguntas.map((pregunta, index) => (
                <Box key={pregunta.preguntaId} sx={{ mb: 4 }}>
                  <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {index + 1}. {pregunta.texto}
                  </Typography>
                  <FormControl component="fieldset">
                    <RadioGroup
                      value={encuesta.RESPUESTAS[pregunta.preguntaId] || ''}
                      onChange={(e) => handleRespuestaChange(pregunta.preguntaId, e.target.value)}
                    >
                      {pregunta.opciones && pregunta.opciones.map((opcion) => (
                        <FormControlLabel
                          key={opcion.opcionRespuestaId}
                          value={opcion.opcionRespuestaId}
                          control={<Radio />}
                          label={opcion.texto}
                          sx={{ 
                            '&:hover': { 
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                              borderRadius: 1
                            }
                          }}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                  {index < preguntas.length - 1 && <Divider sx={{ mt: 2 }} />}
                </Box>
              ))}
            </Paper>
          </Grid>
        )}

        {/* Botones de Acción */}
        {preguntas.length > 0 && (
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12} sm={6} md={3}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={enviarEncuesta}
                  disabled={loading || Object.keys(encuesta.RESPUESTAS).length !== preguntas.length}
                  sx={{ py: 1.5 }}
                >
                  {loading ? 'Enviando...' : 'Enviar Encuesta'}
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Button
                  fullWidth
                  variant="outlined"
                  color="primary"
                  size="large"
                  onClick={volver}
                  sx={{ py: 1.5 }}
                >
                  Volver
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>

      {/* Modales */}
      <ModalClientes
        open={modalClientes}
        handleClose={cerrarModalClientes}
        data={clientes}
        seleccionarCliente={seleccionarCliente}
        datosCargados={datosCargados}
      />

      <ModalEncuestas
        open={modalEncuestas}
        handleClose={cerrarModalEncuestas}
        data={encuestas}
        seleccionarEncuesta={seleccionarEncuesta}
        datosCargados={encuestasCargadas}
      />
    </Container>
  );
}